import PropTypes from "prop-types";
import { TRANSLATION_KEY_CATEGORY_CAROUSEL } from "./constants";
import CarouselWrapper from "./components/CarouselWrapper";

const HorizontalScrollList = ({
  children,
  className,
  isCentralised = true,
  scrollSnapping = false,
  ariaLabel = TRANSLATION_KEY_CATEGORY_CAROUSEL,
  showControlsOnMobile = false,
  visualCategoriesDescription,
  selectedItemSelector,
  selectedItemDependency,
}) => (
  <CarouselWrapper
    scrollSnapping={scrollSnapping}
    className={className}
    ariaLabel={ariaLabel}
    isCentralised={isCentralised}
    showControlsOnMobile={showControlsOnMobile}
    visualCategoriesDescription={visualCategoriesDescription}
    selectedItemSelector={selectedItemSelector}
    selectedItemDependency={selectedItemDependency}
  >
    {children}
  </CarouselWrapper>
);

HorizontalScrollList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isCentralised: PropTypes.bool,
  scrollSnapping: PropTypes.bool,
  ariaLabel: PropTypes.string,
  showControlsOnMobile: PropTypes.bool,
  visualCategoriesDescription: PropTypes.node,
  selectedItemSelector: PropTypes.string,
  selectedItemDependency: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

export default HorizontalScrollList;
